/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/**
 * Simple singleton style container so all CEP related stuff has a centralized point.
 */
var iaw = iaw || { };

iaw.cepUtil = {
	/**
	 * Encapsulated interfaces
	 */
	oneTimeHandler: false,
	csInterface: (window.__adobe_cep__) ? new CSInterface()  : null,
	isStage: null,

	/**
	 * Hosting application and extension data
	 */
	applicationID:	(window.__adobe_cep__) ? new CSInterface().getApplicationID() : 'SIMU',

	/**
	 * Events sent to the hosting application
	 */
	events: {
		EXTENSIONREADY:				'com.adobe.ccx.start.extensionReady',
		LOGPIP:						'com.adobe.ccx.start.LOGPIP',
		kOpenRecentFile:			'com.adobe.ccx.start.handleRecentFileOpen',
		kExecuteMenuCmd:			'com.adobe.ccx.start.handleExecuteMenuCommand',
		kHostStatusChanged: 		'com.adobe.ccx.start.hostStatusChanged',
		REQUESTHOSTCLOSE:			'com.adobe.ccx.start.requestHostClose',
		kOpenDropFiles:				'com.adobe.ccx.start.handleDropFileOpen',
		kOpenPreferences:			'com.adobe.ccx.start.handleOpenPreferences',
		kTrialExpired:				'com.adobe.ccx.start.trialExpired',
		kGetUserJSONDataRequest: 	'com.adobe.ccx.start.getCCXUserJSONData.request',
		kGetUserJSONDataResponse: 	'com.adobe.ccx.start.getCCXUserJSONData.response',
		NEWDOCFROMTEMPLATE:			'com.adobe.ccx.fnft.newDocFromTemplate',
		HOSTCLOSEFNFT:				'com.adobe.ccx.fnft.hostRequestsClose',
		REQUESTDATACALC:			'com.adobe.ccx.fnft.requestDataCalculation',
		UPDATEDATACALC:				'com.adobe.ccx.fnft.updateDataCalculation',
		LOADEXTENSION:				'com.adobe.extension.loadExtension',
		SAVEPRESET: 				'com.adobe.ccx.fnft.savePreset',
		DELETEPRESET: 				'com.adobe.ccx.fnft.deletePreset',
		INTERACTIVEREADY: 			'com.adobe.extension.interactiveReady',
		FNFTSTARTTIME: 				'com.adobe.ccx.fnft.loadStartTime',
		FNFTENDTIME: 				'com.adobe.ccx.fnft.loadEndTime',
		PREVIEWDOCFROMTEMPLATE:     'com.adobe.ccx.fnft.previewDocFromTemplate',
		CLEARPREVIEWDATAONCLOSE:    'com.adobe.ccx.fnft.clearPreviewDataOnClose',
		EARLYKEYEVENTS:             'com.adobe.extension.earlyKeyEvents',
		REQUESTEARLYKEYEVENTS:      'com.adobe.extension.requestEarlyKeyEvents'
	},

	/**
	 * params for jump URL authentication
	 */
	authenticationInfo: {
		adobeStock:	{
			clientID:		'AdobeStockClient1',
			clientScope:	'AdobeID,openid,creative_cloud,read_organizations,gnav,additional_info.address.mail_to,sao.stock'
		},
		adobeLearn: {
			clientID:		'adobedotcom2',
			clientScope :	'creative_cloud,AdobeID,openid,gnav,read_organizations,additional_info.projectedProductContext'
		},
		adobeAccount: {
			clientID:		'adobedotcom2',
			clientScope:	'creative_cloud,AdobeID,openid,gnav,read_organizations,additional_info.projectedProductContext'
		}
	},

	/**
	 * IMS configuration info
	 */
	imsInfo: {
		imsInterface: (window.__adobe_cep__) ? new IMSInterface() : null,

		stageConfig: {
			label:			'Stage',
			clientId:		'CCXInAppWelcomeNew',
			clientSecret:	'c21432bb-5285-4d99-81b4-17de9ee440db',
			scope:			'openid,AdobeID,creative_cloud',
			redirectUri:	'https://oobe.adobe.com',
			imsServer:		'ims-na1-stg1.adobelogin.com'
		},

		productionConfig: {
			label:			'Production',
			clientId:		'CCXInAppWelcomeNew',
			clientSecret:	'e90ce01e-367f-4109-8f4b-0ae0cbd56498',
			scope:			'openid,AdobeID,creative_cloud',
			redirectUri:	'https://oobe.adobe.com',
			imsServer:		'ims-na1.adobelogin.com'
		},
		activeConfig:			null,
		imsRef:					null,
		imsTimeout:				null,
		accessToken:			null,
		accessTokenCallbacks:	[],
		accessTokenInProgress:	false,
		lastAccessTokenTime: 	new Date().valueOf(),
		needRetry: true,

		/**
 		 * Set server environment for IMS.
		 *
		 * @param mode          either 'stage' or 'prod'
		 */
		setEnvironment: function( mode ) {

			this.activeConfig = (mode === 'stage') ? this.stageConfig : this.productionConfig;
		},

		/**
		 * Check to make sure the data event is valid.
		 *
		 * @param event         object containing the access token and other IMS data
		 */
		isIMSDataValid: function( event ) {

			return ( event && event.data && event.data !== '');
		},

		/**
		 * Async callback for returning the IMS token.
		 *
		 * @param event         object containing the access token and other IMS data
		 */
		handleFetchAccessToken: function(event) {
			var self = this;
			if (event && (event.extensionId !== iaw.cepUtil.getExtensionID())) {
				//Should filter out IMS events from other CEP extensions, like photoshop preview.
				return;
			}

			if (event && event.data && event.data.jump) {
				// Should filter out IMS jump event
				return;
			}

			if ( self.imsTimeout ) {
				clearTimeout( self.imsTimeout );
				self.imsTimeout = null;
			}
//            iaw.log.debug('Handling fetch access token callback: ' + JSON.stringify(event));

			// clear the event listener
			self.imsInterface.removeEventListener( self.imsInterface.events.imsFetchAccessToken, self.handleFetchAccessToken );

			// setup access token
			// support both string and object type, because CEP 6.0 takes
			// event.data as an object, CEP 6.1 mainline takes it as a string
			// at the moment. Not sure it's a potential bug or required change
			// in CEP, but Radar should handle both cases.
			if ( self.isIMSDataValid(event) ) {
				switch (typeof event.data) {
					case 'string':
						var imsData;
						try {
							imsData = JSON.parse(event.data);
						}
						catch (e) {
							// ignore
						}
						self.accessToken = (imsData && imsData.access_token) ? imsData.access_token : null;
						break;

					case 'object':
						self.accessToken = event.data.access_token || null;
						break;

					default:
						self.accessToken = null;
						break;
				}
				if (!self.accessToken) {
					iaw.log.console('IMS response event: ' + JSON.stringify(event));
				}
			}
			else {
				iaw.log.console('Failed to get access token: ' + JSON.stringify(event));
			}

			// clear in progress flag...
			self.accessTokenInProgress = false;
			iaw.log.console('IMS accessToken is : ' + self.accessToken);

			if (self.accessToken === null && self.needRetry) {
				// Probably host app hasn't loaded IMS native library yet and it's related to the sequence of loading navtive libraries in host app.
				// So have to retry once for the very first fetch token if it fails.
				// Ideally, host app needs to adjust the sequence of native libraries. But to be releastic, such workaround is not avoidable.
				self.needRetry = false;
				iaw.cepUtil.imsInfo.getAccessToken();
				return;
			}
			// handle all the token requests that may have come in while
			// we were in the fetching process
			var numCallbacks = self.accessTokenCallbacks.length;

			if ( numCallbacks ) {
				self.lastAccessTokenTime = new Date().valueOf();
				for ( var index = 0; index < numCallbacks; ++index ) {
					var callback = self.accessTokenCallbacks[index];

					if ( callback ) { callback(self.accessToken); }
				}
				self.accessTokenCallbacks = [];
			}
		},

		/**
		 * Handle timeout for access token fetch.
		 */
		accessTokenTimeout: function() {

			iaw.log.console('IMS access token fetch has timed out');
			iaw.cepUtil.imsInfo.imsTimeout = null;
			iaw.cepUtil.imsInfo.handleFetchAccessToken(null);
		},

		/**
		 * Retrieve the IMS access token.
		 *
		 * @param callback          function to call upon completion
		 * @return A string containing the access token.
		 */
		getAccessToken: function(callback) {
			if (!iaw.localstorage.userID || iaw.localstorage.userID.length === 0) {
				return callback(new Error('Not logged in'));
			}

			var self = this;
			// make sure we have the configuration setup - if not
			// the set the default to the production configuration
			if ( !self.activeConfig ) { self.activeConfig = self.productionConfig; }

			// make sure we are not already in progress as this is
			// an async exercise when getting the token
			if ( !self.accessTokenInProgress ) {
				// Clear the expired access token
				var currentTime = new Date().valueOf();
				if (currentTime - self.lastAccessTokenTime >= 3600 * 24 * 1000) {
					iaw.log.console('Clear expired access token.');
					self.clearAccessToken();
				}
				if ( self.accessToken && self.accessToken.length !== 0 && callback ) {
					callback(self.accessToken);
					return;
				}

				self.accessTokenInProgress = true;
				if (callback) {
					self.accessTokenCallbacks.push(callback);
				}

				// create the IMS reference object
				if ( !self.imsRef && self.imsInterface ) {
					self.imsRef = self.imsInterface.imsConnect( self.activeConfig.clientId );
				}

				// set the event listener for getting the access token
				// this will cause the specified handler function to fire.
				// need to bind this so that 'this' in callback is exact the same.
				self.imsInterface.addEventListener( self.imsInterface.events.imsFetchAccessToken,
					(function( event ) {
						this.handleFetchAccessToken( event );
					}).bind(this));

				self.imsInterface.imsFetchAccessToken(	self.imsRef,
					self.activeConfig.clientId,
					self.activeConfig.clientSecret,
					iaw.localstorage.userID,
					self.activeConfig.redirectUri,
					self.activeConfig.scope);


				if ( self.imsTimeout ) {
					clearTimeout( self.imsTimeout );
				}

				// If IMS doesn't respond in 10s, assume something went wrong
				self.imsTimeout = setTimeout(self.accessTokenTimeout, 10000);
			}
			else { // token running so just push the callback for later
				self.accessTokenCallbacks.push(callback);
			}
		},

		getIMSAccounts: function() {

			var self = this;
			// make sure we have the configuration setup - if not
			// the set the default to the production configuration
			if ( !self.activeConfig ) { self.activeConfig = self.productionConfig; }

			// create the IMS reference object
			if ( !self.imsRef && self.imsInterface ) {
				self.imsRef = self.imsInterface.imsConnect( self.activeConfig.clientId );
			}

			//fetch the accounts with the client ID
			return self.imsInterface.imsFetchAccounts(self.imsRef, self.activeConfig.clientId);
		},

		/**
		 * Clear access token.
		 */
		clearAccessToken: function() {
			this.accessToken = null;
		},

		/**
		 * Handle the jump continue token call to get the authenicated URL.
		 *
		 * @param imsJumpClientID           client ID
		 * @param imsJumpScope              client scope parameters
		 * @param url                       base URL
		 * @param callback                  completion callback
		 */
		createFetchContinueTokenCall: function(imsJumpClientID, imsJumpScope, url, callback) {

			iaw.log.console('createFetchContinueTokenCall attempting SSO workflows');

			this.imsInterface.addEventListener(this.imsInterface.events.imsFetchContinueToken, callback);
			var baseURL = encodeURIComponent(url);

			this.imsInterface.imsFetchContinueToken(this.imsRef,
													this.accessToken,
													imsJumpClientID,
													baseURL,
													imsJumpScope,
													'token',
													'');
		},

		/**
		 * Create an authenicated jump URL.
		 *
		 * @param imsJumpClientID           client ID
		 * @param imsJumpScope              client scope parameters
		 * @param url                       base URL
		 * @param callback                  completion callback
		 */
		jumpURL: function(imsJumpClientID, imsJumpScope, url, callback) {

			var self = this;
			var handleJumpURL = function(event) { //eslint-disable-line func-style
				self.imsInterface.removeEventListener(self.imsInterface.events.imsFetchContinueToken, handleJumpURL);
				if ( callback ) {
					callback((self.isIMSDataValid(event) && event.data.details.jump) ? event.data.details.jump : url);
				}
			};

			iaw.log.console('Attempting SSO workflows for url ' + url);
			this.createFetchContinueTokenCall(imsJumpClientID, imsJumpScope, url, handleJumpURL);
		},

		/**
		 * Detect IMS environment.
		 * @return true if IMS env is redirected to stage, otherwise false.
		 */
		isStagingRedirectInEffect: function() {

			var answer = false;

			if (!window.__adobe_cep__ || !window.DOMParser) { return answer; }
			try {
				var csInterface = new CSInterface();
				var path = VulcanInterface.getAppPath('creativecloud') + (csInterface.getOSInformation().indexOf('Win') > -1 ? '\\..\\..\\C3Config.xml' : '/../../C3Config.xml');
				iaw.log.console('Path of S3Config.xml: ' + path);
				var result = window.cep.fs.readFile(path);

				if (0 !== result.err) {
					return answer;
				}

				var xmlDoc		= new DOMParser().parseFromString(result.data, 'text/xml');
				var configNode	= xmlDoc.getElementsByTagName('C3Config')[0].getElementsByTagName('config')[0];

				if (configNode) {
					var namespaces = configNode.getElementsByTagName('namespace');

					for (var index = 0; index < namespaces.length; index++) {
						var namespace = namespaces[index];

						if (namespace && namespace.getAttribute('name') === 'accc.container') {
							var properties = namespace.getElementsByTagName('property');

							for (var i=0; i< properties.length; i++) {
								var property = properties[i];

								if (property && property.getAttribute('name') === 'IMS_ENV') {
									// We found the IMS environment setting. See if stage redirection is in effect.
									var pVal = property.firstChild.nodeValue;

									if (pVal === 'STG') {
										answer = true;
									}
								}
							}
						}
					}
				}
			}
			catch (ignore) {
				// ignore catches
			}
			return answer;
		}
	}, // end imsInfo container

	/**
	 * Indicate IMS operations are valid.
	 *
	 * @return boolean value indicating true if IMS is available, false otherwise
	 */
	imsValid: function() {

		return Boolean(this.imsInfo.imsInterface);
	},

	/**
	 * Execute an ExtendScript DOM script.
	 *
	 * @param script        script to execute
	 * @param callback      completion callback method
	 */
	evalExtendScript: function(script, callback) {

		// make sure we have a callback
		if ( !callback ) {
			callback = function(result) { };
		}

		// call CEP ExtendScript processor
		if ( window.__adobe_cep__ ) {
			window.__adobe_cep__.evalScript( script, callback );
		}
		else {
			callback( null );
		}
	},

	/**
	 * Evaluate an extend script after first building the string from a command name and zero or more parameters
	 * The last argument must be a callback
	 *
	 * If a param is an object, it will use JSON.stringify
	 * That JSON, and other string params, will be escaped properly
	 *
	 * example:
	 * iaw.cepUtil.evalExtendScriptWithParams('CCXWelcomeXSHost_PHXS.createDocumentFromTemplate',
	 *    tempObj, docName, showDialog, iaw.fnft.closeExtOnStatus)
	 *
	 * @param {string} commandName
	 * @param {object|string|number=} param optional, zero or more
	 * @param {function} callback final argument must be a callback
	 */
	evalExtendScriptWithParams: function() {
		if (arguments.length < 2) {
			throw new Error('evalExtendScriptWithParams needs at least two arguments: script and callback');
		}

		var args = Array.prototype.slice.call(arguments),
			callback = args.pop(),
			commandName = args.shift(),
			paramsArray,
			script;

		paramsArray = args.map(function(arg) {
			var param = (typeof arg === 'object') ? JSON.stringify(arg) : arg;

			if (typeof param === 'string') {
				return '"' + param.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
			}
			else {
				return param;
			}
		});

		script = commandName + '(' + paramsArray.join(',') + ')';

		// call CEP ExtendScript processor
		if ( window.__adobe_cep__ ) {
			window.__adobe_cep__.evalScript( script, callback );
		}
		else {
			callback( null );
		}
	},

	/**
	 * Send an event back to the hosting application.
	 *
	 * @param eventType         type of event, @see this.events
	 * @param eventData         data to be sent along with the event
	 * @param optExtensionID	optional extension override ID
	 */
	sendEvent: function(eventType, eventData, optExtensionID) {

		if ( window.__adobe_cep__ ) {
			var event = new CSEvent();

			event.scope         = 'APPLICATION';
			event.appId         = this.applicationID;
			event.extensionId   = optExtensionID || iaw.cepUtil.getExtensionID();
			event.type          = eventType;
			event.data          = eventData;

			this.csInterface.dispatchEvent(event);
		}
	},

	/**
	 * Retrieves the Hello CEP extension's ID from the manifest XML.
	 *
	 * @return A string containing the ID from the manifest.
	 */
	getExtensionID: function() {

		return ( window.__adobe_cep__ && this.csInterface ) ? this.csInterface.getExtensionID() : '';
	},

	/**
	 * Retrieves the Hello CEP extension's version from the manifest XML.
	 *
	 * @param useBundeledVersion    boolean to indicate which of two possible
	 *                                  version numbers to use
	 * @return A string containing the version from the manifest.
	 */
	getExtensionVersion: function( useBundleVersion ) {

		var verInfo = { version : '0.0.0', sha : null };

		if ( window.__adobe_cep__ ) {
			var csInterface     = this.csInterface;
			var extensionDir    = csInterface.getSystemPath(SystemPath.EXTENSION);

			// since we are reading from a local file, it is OS specific so we
			// will need the proper path separator
			var os              = csInterface.getOSInformation();
			var pathSeparator   = os.indexOf('Win') >= 0 ? '\\' : '/';
			var manifestPath    = extensionDir + pathSeparator + 'CSXS' + pathSeparator + 'manifest.xml';
			var fileContents    = window.cep.fs.readFile( manifestPath );

			if ( window.DOMParser ) {
				var parser              = new window.DOMParser();
				var xmlDoc              = parser.parseFromString( fileContents.data, 'text/xml' );
				var extManifestElement  = xmlDoc.getElementsByTagName( 'ExtensionManifest' )[0];

				if ( typeof extManifestElement !== 'undefined' && extManifestElement ) {
					verInfo.sha = extManifestElement.attributes.getNamedItem('SHA').nodeValue;
					verInfo.version = ( !useBundleVersion ) ?
						extManifestElement.getElementsByTagName( 'ExtensionList' )[0].firstElementChild.attributes.getNamedItem('Version').nodeValue :
						extManifestElement.attributes.getNamedItem('ExtensionBundleVersion').nodeValue;
				}
			}
		}
		return verInfo;
	},

	/**
	 * Async check if user signed in or not.
	 * @param callback      callback method which takes the following parameters:
	 *                          a boolean value to indicate user signed in or not
	 *                          if true, the logged in Adobe GUID is passed in the
	 *                          second parameter, if false, the second parameter
	 *                          will be null
	 */
	isUserSignedIn: function(callback) {
		if (!iaw.localstorage.userID || iaw.localstorage.userID.length === 0) {
			return callback(false, null);
		}
		return callback(true, iaw.localstorage.userID);
	},

	/**
	 * Initialize IMS to either the stage or production (default) servers.
	 *
	 * @param mode          either 'stage' or 'prod'
	 */
	setEnvironment: function( mode ) {

		if ( this.imsInfo.imsInterface ) {
			this.imsInfo.setEnvironment( mode );
		}
	},

	/**
	 * Determine if we are using the stage IMS servers or the production.
	 *
	 * @return true if on the IMS stage authentication, false otherwise.
	 */
	usingStageAuthentication: function() {
		// Production end users never need stage redirection
		// Therefore it does not make sense to make them incur an additional
		// cost of stage redirection detection on every load. If you ever redirect
		// to stage on the machine, then we store this information in local storage
		// and add this cost for you. Otherwise we lazily check and reload setting this
		// flag.
		if (this.isStage === null) {
			var needsStageLookup = iaw.localstorage.getGlobalItem('needsStageLookup');
			if (needsStageLookup) {
				this.isStage = this.imsInfo.isStagingRedirectInEffect();
			}
			else {
				var self = this;
				riotctrl.once('update-details-retro', function() {
					self.isStage = self.imsInfo.isStagingRedirectInEffect();
					if (self.isStage) {
						iaw.localstorage.setGlobalItem('needsStageLookup', true);
						window.location.reload();
					}
				});

				return false;
			}
		}
		return this.isStage;
	},

	/**
	 * Get the IMS authentication token for the current user. This is
	 * an asynchronous call so requires a completion callback which
	 * gets called when the process has been completed.
	 *
	 * @param callback          completion callback
	 */
	getIMSAccessToken: function( callback ) {

		if ( this.imsInfo.imsInterface ) {
			this.imsInfo.getAccessToken( callback );
		}
	},

	getIMSClientId: function() {
		if (!this.imsInfo.activeConfig) { this.imsInfo.activeConfig = this.imsInfo.productionConfig; }
		return this.imsInfo.activeConfig.clientId;
	},

	getPrimaryAccountType: function() {

		var accountType = '';
		var accounts = '';

		try {
			if (this.imsInfo.imsInterface) {
				accounts = this.imsInfo.getIMSAccounts();
			}
			var xmlDoc = new DOMParser().parseFromString(accounts, 'text/xml');
			var accType	= xmlDoc.getElementsByTagName('UserAccounts')[0].getElementsByTagName('UserData')[0].getElementsByTagName('AccountType')[0];
			if (accType) {
				accountType = accType.firstChild.nodeValue;
			}
		}
		catch (e) {
			iaw.log.console('Exception in fetching account type');
			iaw.log.exception('Fetch account type exception: ' + e.message);
		}
		return accountType;
	},

	/**
	 * Clear access token.
	 */
	clearAccessToken: function() {
		if ( this.imsInfo.imsInterface ) {
			this.imsInfo.clearAccessToken();
		}
	},

	/**
	 * Get the current UI theme color.
	 *
	 * @return A color object containing the current UI color setting.
	 */
	getUIThemeColor: function() {

		return ( this.csInterface ) ? this.csInterface.getHostEnvironment().appSkinInfo.panelBackgroundColor.color : null;
	},

	/**
	 * Attaches the theme change listener to detect the theme changes from
	 * the host application.
	 */
	addThemeChangeListener: function() {

		if ( this.csInterface ) {
			this.csInterface.addEventListener( 'com.adobe.csxs.events.ThemeColorChanged', (function( event ) {
				iaw.util.setUIThemeMode();
			}).bind(this));
		}
	},

	/**
	 * Create a authenticated jump URL based on client specification.
	 *
	 * @param clientID      SSO client ID
	 * @param clientScope   SSO client scope
	 * @param url           base url
	 * @param callback      callback method which takes the following parameters:
	 *                          the jump url to deal with
	 */
	createJumpURL: function(clientID, clientScope, url, callback) {
		if ( this.imsValid ) {
			this.imsInfo.jumpURL(clientID, clientScope, url, callback);
		}
	},

	/**
	 * Return the path to the extensions root folder.
	 *
	 * @return A string containing the extensions root path or null if CEP is not being used.
	 */
	getExtensionPath: function() {

		var path = null;

		if ( this.csInterface ) {
			var os              = this.csInterface.getOSInformation();
			var pathSeparator   = os.indexOf('Win') >= 0 ? '\\' : '/';

			path = this.csInterface.getSystemPath(SystemPath.EXTENSION)+pathSeparator;
		}
		return path;
	}
};
